import {parseDate}       from "@Common/utils/date-object";
import {parseDateFormat} from "@Common/utils/date/parse-date-format";

export const formatDate = (() => {
    const df = parseDateFormat("yyyy/mm/dd");
    return (str) => df.formatDate(parseDate(str));
})();
